"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
function useFreezeHeight({ isLoading, }) {
    const elementRef = react_1.useRef(null);
    const styleRef = react_1.useRef({});
    react_1.useLayoutEffect(() => {
        var _a;
        const height = (_a = elementRef.current) === null || _a === void 0 ? void 0 : _a.clientHeight;
        if (height && !isLoading) {
            styleRef.current = { height };
        }
    }, [isLoading]);
    return { elementRef, style: styleRef.current };
}
exports.default = useFreezeHeight;
